export default __webpack_public_path__ + "static/media/fsd.d3c82fd2.bin";